import { 
	createSlice, 
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {envAwarePost} from '../util/util'

export const getAllNotes = createAsyncThunk(
	'notes/getAll',
	async payload => envAwarePost('api/events/',{
		action:'getNotes',
		...payload
	})
)


export const getRecentNotes = createAsyncThunk(
	'notes/getRecentNotes',
	async payload => envAwarePost('api/client/api/',{
		action:'recentNotes',
		...payload
	})
)

export const initNotes = createAsyncThunk(
	'notes/getRecentNotes',
	async payload => envAwarePost('api/client/api/',{
		action:'recentNotes',
		...payload
	})
)

export const saveNote = createAsyncThunk(
	'notes/saveNote',
	async payload => envAwarePost('api/client/api/',{
		action:'addNote',
		...payload
	})
)

export const updateNote = createAsyncThunk(
	'notes/updateNote',
	async payload => envAwarePost('api/client/api/',{
		action:'updateNote',
		...payload
	})
)

export const deleteNote = createAsyncThunk(
	'notes/deleteNote',
	async payload => envAwarePost('api/client/api/',{
		action:'deleteNote',
		...payload
	})
)

export const deleteNotes = createAsyncThunk(
	'notes/deleteNotes',
	async payload => envAwarePost('api/client/api/',{
		action:'deleteNotes',
		...payload
	})
)

const notesAdapter = createEntityAdapter({
	selectId:ent=>ent.note_id
})

const clientNotesSlice = createSlice({
	name: 'clientNotes',
	initialState:{
		status:'empty',
		adapter:notesAdapter.getInitialState()
	},
	reducers: {},
	extraReducers:{
		[getRecentNotes.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if(success === '1') notesAdapter.upsertMany(state.adapter,data.notes||[])
		},
		[initNotes.pending] : (state,action)=>{
			state.status="loading"
			state.adapter.ids = []
			state.adapter.entities = {}
		},
		[initNotes.fulfilled] : (state,action)=>{
			state.status="idle"
			const {success,data} = action.payload
			if(success === '1') notesAdapter.upsertMany(state.adapter,data.notes||[])
		},
		[saveNote.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if(success === '1'){
				state.adapter.entities[data.note_id] = data
				state.adapter.ids.unshift(data.note_id)
			}
		},
		[deleteNote.pending] : (state,action)=>{
			const {note_id} = action.meta.arg
			notesAdapter.removeOne(state.adapter,note_id)
		},
		[deleteNotes.pending] : (state,action)=>{
			const {ids} = action.meta.arg
			notesAdapter.removeMany(state.adapter,ids)
		},
		[updateNote.pending] : (state,action)=>{
			const {note_id,note,dateCreated} = action.meta.arg
			notesAdapter.updateOne(state.adapter,{
				id:note_id,
				changes:{note, dateCreated}
			})
		},
		[getAllNotes.pending] : (state,action)=>{
			notesAdapter.setAll(state.adapter,[])
		},

		[getAllNotes.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if(success === '1') notesAdapter.setAll(state.adapter,data.notes||[])
		},
	}
})

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllNotes,
	selectById: selectNoteById,
	selectIds: selectNotesIds
} = notesAdapter.getSelectors(state => state.clientNotes.adapter)


export default clientNotesSlice.reducer